import socketTypes from './socketTypes';

const INITIAL_STATE = {
  socket: null,
  cleanup: null,
};

const socketReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case socketTypes.CONNECT: {
      return {
        socket: action.payload.socket,
        cleanup: action.payload.cleanup,
      };
    }
    case socketTypes.DISCONNECT: {
      if (state.cleanup) {
        state.cleanup();
      }
      if (state.socket) {
        state.socket.disconnect();
      }
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
};

export default socketReducer;
